import { gql } from '__generated__';

export default gql(`
  mutation EditTicketCategory($input: EditTicketCategoryInput!) {
    editTicketCategory(input: $input) {
      id
    }
  }
`);
